import axios from 'axios';
import { API_URL } from '../config';

const API = API_URL;

// Get auth headers
const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`
});

// Songs API
export const songsApi = {
  // Get paginated songs with filters and sorting
  getAll: async (page = 1, limit = 20, filters = {}) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    // Add filters if present
    if (filters.genre && filters.genre !== 'all') params.append('genre', filters.genre);
    if (filters.rating && filters.rating !== 'all') params.append('rating', filters.rating);
    if (filters.rating_min && filters.rating_min !== 'all') params.append('rating_min', filters.rating_min);
    if (filters.momento && filters.momento !== 'all') params.append('momento', filters.momento);
    if (filters.energia && filters.energia !== 'all') params.append('energia', filters.energia);
    if (filters.decade) params.append('decade', filters.decade);
    if (filters.favorito !== undefined) params.append('favorito', filters.favorito);
    if (filters.pendiente_denon !== undefined) params.append('pendiente_denon', filters.pendiente_denon);
    if (filters.search) params.append('search', filters.search);
    
    // Add sorting parameters - ALWAYS send these with default fallbacks
    params.append('sort_by', filters.sortBy || 'title');
    params.append('sort_order', filters.sortOrder || 'desc');
    
    console.log('[songsApi.getAll] Requesting:', `${API}/songs?${params.toString()}`);
    
    const { data } = await axios.get(`${API}/songs?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    
    console.log('[songsApi.getAll] Response: total=', data?.pagination?.total, 'songs=', data?.data?.length);
    
    return data;
  },
  
  // Get ALL songs without pagination (for special operations)
  getAllNoPagination: async () => {
    const { data } = await axios.get(`${API}/songs/all`, {
      headers: getAuthHeaders()
    });
    return data;
  },
  
  // Get all unique filter values (genres, momentos, energia, ratings)
  getFilterValues: async () => {
    const { data } = await axios.get(`${API}/songs/filters/values`, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Get song by ID
  getById: async (songId) => {
    const { data } = await axios.get(`${API}/songs/${songId}`, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Create song
  create: async (songData) => {
    const { data } = await axios.post(`${API}/songs`, songData, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Update song
  update: async (updateData) => {
    // Extract id (songId) from updateData
    const { id, ...songData } = updateData;
    const { data } = await axios.put(`${API}/songs/${id}`, songData, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Delete song
  delete: async (songId) => {
    const { data } = await axios.delete(`${API}/songs/${songId}`, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Get Denon pendientes count
  getDenonPendientesCount: async () => {
    const { data } = await axios.get(`${API}/songs/stats/denon-pendientes`, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Create Denon playlist
  createDenonPlaylist: async () => {
    const { data } = await axios.post(`${API}/songs/create-denon-playlist`, {}, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Detect duplicates
  detectDuplicates: async () => {
    const { data } = await axios.get(`${API}/songs/detect-duplicates`, {
      headers: getAuthHeaders()
    });
    return data;
  },

  // Search Spotify
  searchSpotify: async ({ title, artist }) => {
    const params = new URLSearchParams();
    if (title) params.append('title', title);
    if (artist) params.append('artist', artist);
    
    const { data } = await axios.get(`${API}/songs/search-spotify?${params}`, {
      headers: getAuthHeaders()
    });
    return data;
  },
};
